import { View } from "extensions/marionette";

import textInputTemplate from "./textInput.jst";

export const TextInput = View.extend({
    className: "form-control",
    template: textInputTemplate,
    ui: {
        input: ".query-builder-text-input"
    },
    events: {
        click(e) {
            if (e.target.tagName.toLowerCase() !== "input") {
                this.ui.input.focus();

                // Set cursor at the very end of the input
                const l = this.ui.input.val().length;
                this.ui.input[0].setSelectionRange(l, l);
            }
        },
        keypress(e) {
            if (e.which === 13) {
                this.triggerMethod("apply");
            }
        }
    },
    templateContext() {
        return {
            qualifiers: this.getOption("qualifiers")
        };
    },

    getValue() {
        // TODO: journey validate input
        return this.ui.input.val();
    }
});
